export default "__VITE_ASSET__g6Gje01Z__"